module.exports = __webpack_public_path__ + "static/media/myanmar-flag.f116c85b.png";